import React from "react";
import { RouteProps } from "react-router-dom";
import { Rota } from "@intechprev/componentes-web";

import {
  Login,
  EsqueciSenha,
  Termos,
  TrocarSenhaPrimeiroAcesso,
  Home,
  Contracheque,
  ContrachequeDetalhe,
  Documentos,
  DadosPessoais,
  InformeRendimentos,
  Planos,
  PlanoSaude,
  Recadastramento,
  Relacionamento,
  TrocarSenha,
  Emprestimos,
  Formularios,
  EmprestimoDetalhe,
  ListarParticipantes,
  SimuladorEmprestimo,
  SimuladorEmprestimoPrestacoes,
  SimuladorRendaMensal,
  SimuladorRendaMensalResultado,
  Eventos,
} from "./pages";
import { SelecionarMatricula } from "./pages/Login/SelecionarMatricula";
import { SimuladorEmprestimoResumo, SimuladorEmprestimoContratacao } from "./pages/Emprestimos";
import { Comprovantes } from "./pages/Comprovantes";
import { ComprovanteDetalhe } from "./pages/Comprovantes/Detalhe";
import { EmprestimosInforme } from "./pages/Emprestimos/Informe";
import { DeclaracaoIR } from "./pages/DeclaracaoIR";

const rotas: Array<Rota> = [
  {
    titulo: "Login",
    caminho: "/login",
    componente: (routeProps: RouteProps) => <Login {...routeProps} />,
    mostrarMenu: false,
    caminhoExato: true,
    id: "login",
    icone: "",
  },
  {
    titulo: "Esqueci Minha Senha",
    caminho: "/esqueciSenha",
    componente: (routeProps: RouteProps) => <EsqueciSenha {...routeProps} />,
    mostrarMenu: false,
    caminhoExato: false,
    id: "",
  },
  {
    titulo: "Termos",
    caminho: "/termos",
    componente: (routeProps: RouteProps) => <Termos {...routeProps} />,
    mostrarMenu: false,
    caminhoExato: false,
    id: "",
  },
  {
    titulo: "Trocar Senha",
    caminho: "/trocarSenhaPrimeiroAcesso",
    componente: (routeProps: RouteProps) => <TrocarSenhaPrimeiroAcesso {...routeProps} />,
    mostrarMenu: false,
    caminhoExato: false,
    id: "",
  },
  {
    titulo: "Home",
    icone: "fas fa-home",
    caminho: "/",
    componente: (routeProps: RouteProps) => <Home {...routeProps} />,
    mostrarMenu: true,
    caminhoExato: true,
    id: "home",
  },
  {
    titulo: "Seus Dados",
    icone: "fas fa-user",
    caminho: "/dados",
    componente: (routeProps: RouteProps) => <DadosPessoais {...routeProps} />,
    mostrarMenu: true,
    id: "dados",
  },
  {
    titulo: "Extrato",
    icone: "fas fa-file-alt",
    caminho: "/planos",
    componente: (routeProps: RouteProps) => <Planos {...routeProps} />,
    mostrarMenu: true,
    id: "planos",
  },
  {
    titulo: "Contracheque",
    icone: "fas fa-closed-captioning",
    caminho: "/contracheque",
    componente: (routeProps: RouteProps) => <Contracheque {...routeProps} />,
    mostrarMenu: true,
    id: "contracheque",
  },
  {
    titulo: "Empréstimos",
    icone: "fas fa-handshake",
    caminho: "/emprestimos",
    componente: (routeProps: RouteProps) => <Emprestimos {...routeProps} />,
    mostrarMenu: true,
    id: "emprestimos",
  },
  {
    titulo: "Empréstimos - Detalhe",
    icone: "fas fa-handshake",
    caminho: "/emprestimodetalhe/:numero/:ano",
    caminhoLink: "/emprestimodetalhe/",
    componente: (routeProps: RouteProps) => <EmprestimoDetalhe {...routeProps} />,
    mostrarMenu: false,
    id: "",
  },
  {
    titulo: "Simulação e Contratação de Empréstimos",
    icone: "fas fa-handshake",
    caminho: "/simuladorEmprestimo",
    componente: (routeProps: RouteProps) => <SimuladorEmprestimo {...routeProps} />,
    mostrarMenu: false,
    id: "",
  },
  {
    titulo: "Simulação e Contratação de Empréstimos",
    icone: "fas fa-handshake",
    caminho: "/simuladorEmprestimoPrestacoes",
    componente: (routeProps: RouteProps) => <SimuladorEmprestimoPrestacoes {...routeProps} />,
    mostrarMenu: false,
    id: "",
  },
  {
    titulo: "Simulação e Contratação de Empréstimos",
    icone: "fas fa-handshake",
    caminho: "/simuladorEmprestimoResumo",
    componente: (routeProps: RouteProps) => <SimuladorEmprestimoResumo {...routeProps} />,
    mostrarMenu: false,
    id: "",
  },
  {
    titulo: "Simulação e Contratação de Empréstimos",
    icone: "fas fa-handshake",
    caminho: "/simuladorEmprestimoContratacao",
    componente: (routeProps: RouteProps) => <SimuladorEmprestimoContratacao {...routeProps} />,
    mostrarMenu: false,
    id: "",
  },
  {
    id: "emprestimosInforme",
    caminho: "/emprestimosInforme",
    titulo: "Informe para Fins de IR",
    componente: (routeProps: RouteProps) => <EmprestimosInforme {...routeProps} />,
    icone: "fas fa-handshake",
    mostrarMenu: false,
  },
  {
    titulo: "Simulador de Renda",
    icone: "fas fa-money-bill-wave",
    caminho: "/simuladorRendaMensal",
    componente: (routeProps: RouteProps) => <SimuladorRendaMensal {...routeProps} />,
    mostrarMenu: true,
    id: "simuladorRendaMensal",
  },
  {
    titulo: "Simulador Renda Mensal Vitalícia",
    icone: "fas fa-money-bill-wave",
    caminho: "/simuladorRendaMensalResultado/:rentabilidadeAnual/:taxaContribuicao/:taxaResgate/:dataInicioRMV/:dataAporte/:valorAporte",
    caminhoLink: "/simuladorRendaMensalResultado/",
    componente: (routeProps: RouteProps) => <SimuladorRendaMensalResultado {...routeProps} />,
    mostrarMenu: false,
    id: "simuladorRendaMensalResultado",
  },
  {
    titulo: "Inf. Rendimentos",
    icone: "fas fa-chart-pie",
    caminho: "/infoRend",
    componente: (routeProps: RouteProps) => <InformeRendimentos {...routeProps} />,
    mostrarMenu: true,
    id: "informeRendimentos",
  },
  {
    titulo: "Contribuições para Fins de IR",
    icone: "fas fa-file-alt",
    caminho: "/declaracaoIR",
    componente: (routeProps: RouteProps) => <DeclaracaoIR {...routeProps} />,
    mostrarMenu: true,
    id: "declaracaoIR",
  },
  {
    titulo: "Informe Plano de Saúde",
    icone: "fas fa-file-medical",
    caminho: "/planoSaude",
    componente: (routeProps: RouteProps) => <PlanoSaude {...routeProps} />,
    mostrarMenu: true,
    id: "planoSaude",
  },
  {
    titulo: "Formulários",
    icone: "fas fa-file-alt",
    caminho: "/formularios",
    componente: (routeProps: RouteProps) => <Formularios {...routeProps} />,
    mostrarMenu: true,
    id: "formularios",
  },
  {
    titulo: "Contracheque Detalhe",
    icone: "fas fa-closed-captioning",
    caminho: "/contrachequedetalhes/:plano/:data/:cdTipoFolha/:cdEspecie",
    caminhoLink: "/contrachequedetalhes/",
    componente: (routeProps: RouteProps) => <ContrachequeDetalhe {...routeProps} />,
    mostrarMenu: false,
    id: "",
  },
  {
    titulo: "Eventos",
    icone: "fas fa-file",
    caminho: "/eventos/:oidEvento",
    caminhoLink: "/eventos/",
    componente: (routeProps: RouteProps) => <Eventos {...routeProps} />,
    mostrarMenu: false,
    caminhoExato: true,
    id: "eventos",
  },
  {
    titulo: "Eventos",
    icone: "fas fa-file",
    caminho: "/eventos",
    caminhoLink: "/eventos/",
    componente: (routeProps: RouteProps) => <Eventos {...routeProps} />,
    mostrarMenu: true,
    caminhoExato: true,
    id: "eventos",
  },
  {
    titulo: "Documentos",
    icone: "fas fa-file",
    caminho: "/documentos/:pasta?",
    caminhoLink: "/documentos/",
    componente: (routeProps: RouteProps) => <Documentos {...routeProps} />,
    mostrarMenu: false,
    id: "documentos",
  },
  {
    titulo: "Documentos",
    icone: "fas fa-file",
    caminho: "/documentos",
    caminhoLink: "/documentos/",
    componente: (routeProps: RouteProps) => <Documentos {...routeProps} />,
    mostrarMenu: true,
    id: "documentos",
  },
  {
    titulo: "Recadastramento",
    icone: "fas fa-address-card",
    caminho: "/recadastramento",
    componente: (routeProps: RouteProps) => <Recadastramento {...routeProps} />,
    mostrarMenu: true,
    id: "recadastramento",
  },
  {
    titulo: "Comprovantes",
    icone: "fas fa-clipboard",
    caminho: "/comprovantes",
    componente: (routeProps: RouteProps) => <Comprovantes {...routeProps} />,
    mostrarMenu: true,
    id: "recadastramento",
  },
  {
    titulo: "Comprovante",
    icone: "fas fa-clipboard",
    caminho: "/comprovantesDetalhe/:oid",
    caminhoLink: "/comprovantesDetalhe",
    componente: (routeProps: RouteProps) => <ComprovanteDetalhe {...routeProps} />,
    mostrarMenu: false,
    id: "recadastramento",
  },
  {
    titulo: "Fale Conosco",
    icone: "fas fa-envelope",
    caminho: "/relacionamento",
    componente: (routeProps: RouteProps) => <Relacionamento {...routeProps} />,
    mostrarMenu: true,
    id: "relacionamento",
  },
  {
    titulo: "Trocar senha",
    icone: "fas fa-key",
    caminho: "/trocarSenha",
    componente: (routeProps: RouteProps) => <TrocarSenha {...routeProps} />,
    mostrarMenu: true,
    id: "trocarSenha",
  },
  {
    titulo: "Listar Participantes",
    caminho: "/listarParticipantes",
    componente: (routeProps: RouteProps) => <ListarParticipantes {...routeProps} />,
    mostrarMenu: false,
    id: "listarParticipantes",
  },
  {
    titulo: "Selecionar Matrícula",
    caminho: "/selecionarMatricula",
    componente: (routeProps: RouteProps) => <SelecionarMatricula {...routeProps} />,
    mostrarMenu: true,
    caminhoExato: true,
    id: "selecionarMatricula",
    icone: "fas fa-sync-alt",
  },
];

export default rotas;
